import React, { useEffect, useState } from "react";
import home from "../Images/Home/home.jpg";
import login from "../Images/How/login.png";
import search from "../Images/How/search.png";
import pay from "../Images/How/pay.png";
import confirm from "../Images/How/confirm.png";
import booking from "../Images/Why/booking.jpg";
import choice from "../Images/Why/choice.png";
import money from "../Images/Why/money.png";
import axios from "../shared";
import Carousel from "react-elastic-carousel";

const HomePage = () => {
  const [review, setReview] = useState({});

  const text = {
    background: "linear-gradient(to right, #fff 40%, #000 60%)",
    backgroundClip: "text",
    WebkitBackgroundClip: "text",
    color: "transparent",
  };

  useEffect(() => {
    const fetchReview = async () => {
      try {
        const response = await axios.get("review/");
        //filtering data based on doctor id
        const filteredValues = Object.values(response.data).filter((value) => {
          return value.to === "System";
        });

        setReview(filteredValues);
      } catch (error) {
        console.log("Server Down");
      }
    };
    fetchReview();
  }, []);

  return (
    <>
      <div className="position-relative">
        <img src={home} className="w-100" height={500} alt="home" />
        <div
          className="d-flex flex-column w-100 align-items-center gap-2 position-absolute"
          style={{ top: 25 + "%" }}
        >
          <h1 style={text} className="text-center">
            Thinking of Booking Appointment?
          </h1>
          <h2 style={text}>Book Doctor of Your Choice</h2>
          <div className="d-flex mt-4 justify-content-around w-50">
            <a
              href="doctor"
              className="btn btn-light px-md-4 px-3 text-black fs-5"
            >
              Book
            </a>
            <a
              href="#why-us"
              className="btn btn-dark px-md-4 px-3 text-white fs-5"
            >
              Why Us?
            </a>
          </div>
        </div>
      </div>

      <div className="mx-5">
        <div className="border rounded p-4 my-5 m-md-5">
          <h2 className="text-center mb-4">How System Works?</h2>
          <div className="row row-cols-4 text-center justify-content-evenly">
            <div className="col w-auto">
              <img
                src={login}
                height={200}
                className="img-circle"
                alt="Log in"
              />
              <h5 className="mt-2">
                <i className="fa-duotone fa-1 border text-info border-primary rounded-circle px-2 me-1"></i>{" "}
                Log In
              </h5>
            </div>
            <div className="col w-auto">
              <img src={search} height={200} alt="Choose doctor" />
              <h5 className="mt-2">
                <i className="fa-duotone fa-2 border text-info border-primary rounded-circle px-2 me-1"></i>{" "}
                Choose Doctor
              </h5>
            </div>
            <div className="col w-auto">
              <img src={pay} height={200} alt="Pay fees" />
              <h5 className="mt-2">
                <i className="fa-duotone fa-3 border text-info border-primary rounded-circle px-2 me-1"></i>{" "}
                Pay Fee
              </h5>
            </div>
            <div className="col w-auto">
              <img src={confirm} height={200} alt="Confirm book" />
              <h5 className="mt-2">
                <i className="fa-duotone fa-4 border text-info border-primary rounded-circle px-2 me-1"></i>{" "}
                Confirm Booking
              </h5>
            </div>
          </div>
        </div>

        <div className="border rounded p-4 my-5 m-md-5" id="why-us">
          <h2 className="text-center mb-4">Why Us?</h2>
          <div className="row row-cols-3 text-center justify-content-evenly">
            <div className="col w-auto p-4">
              <h5>Easy Booking Process</h5>
              <img src={booking} height={200} width={250} alt="easy booking" />
            </div>
            <div className="col w-auto p-4">
              <h5>Plenty of Choice</h5>
              <img
                src={choice}
                height={200}
                width={250}
                alt="plenty of choice"
              />
            </div>
            <div className="col w-auto p-4">
              <h5>Affordable Price</h5>
              <img src={money} height={200} width={250} alt="affordable" />
            </div>
          </div>
        </div>

        <div className="border rounded p-4 my-5 m-md-5">
          <h2 className="text-center mb-4">Patient Review?</h2>
          <div
            className={`row row-cols-${
              review.length === 1 ? "1" : review.length === 2 ? "2" : "3"
            } justify-content-evenly`}
          >
            {review.length > 0 ? (
              <Carousel
                itemsToShow={3}
                pagination={true}
                breakPoints={[
                  { width: 1, itemsToShow: 1 },
                  { width: 550, itemsToShow: 2 },
                  { width: 850, itemsToShow: 3 },
                ]}
              >
                {review.map((review, i) => (
                  <div key={i}>
                    <div className="d-flex justify-content-center flex-column flex-md-row align-items-center">
                      <img
                        src={review.review_by.user_detail.user_image}
                        className="rounded-circle"
                        height={100}
                        alt="user"
                      />
                      <p className="m-0 ms-2">{review.description}</p>
                    </div>
                    <label className="text-end w-100 m-0">
                      - {review.review_by.user_detail.name}
                    </label>
                  </div>
                ))}
              </Carousel>
            ) : (
              <h5 className="text-center w-100 text-danger">No Reviews</h5>
            )}
          </div>
          <p className="text-end mx-5">
            Provide us your valuable feedback too.{" "}
            <a href="/give/review">Review</a>
          </p>
        </div>
      </div>
    </>
  );
};

export default HomePage;
